var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSortBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 9.12793,
    y: 4.14941,
    width: 1.65957,
    height: 11.617,
    rx: 0.829787,
    fill: "#7B88A8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.56595 10.5447C5.2419 10.8687 4.7165 10.8687 4.39245 10.5447C4.0684 10.2206 4.0684 9.69523 4.39245 9.37118L9.37118 4.39246C9.68532 4.07832 10.1911 4.06732 10.5186 4.36752L15.4974 8.93135C15.8352 9.24102 15.858 9.76592 15.5483 10.1037C15.2387 10.4416 14.7138 10.4644 14.3759 10.1547L9.98288 6.12774L5.56595 10.5447Z",
    fill: "#7B88A8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSortBy);
export default __webpack_public_path__ + "static/media/arrow-sort-by.6c9a128f61d29e926a3ea5a9df482d9b.svg";
export { ForwardRef as ReactComponent };